module.exports = "<button class=\" btn btn-secondary reset\" (click)=\"resetfn.emit()\">Reset</button>"